export enum EmailTemplateFormTab {
    Creation = 'creation',
    Preview = 'preview',
}